import { render, staticRenderFns } from "./footer-gray.vue?vue&type=template&id=400652a6&scoped=true"
import script from "./footer-gray.vue?vue&type=script&lang=js"
export * from "./footer-gray.vue?vue&type=script&lang=js"
import style0 from "./footer-gray.vue?vue&type=style&index=0&id=400652a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400652a6",
  null
  
)

export default component.exports